export default __webpack_public_path__ + "static/media/gallery_03.cf585fe0.jpg";